// removed by extract-text-webpack-plugin
module.exports = {"main":"LocationsHeader-main--54SC5","groupedItems":"LocationsHeader-groupedItems--8z7RI","label":"LocationsHeader-label--p8uGf","labelContent":"LocationsHeader-labelContent--2uM_1","item":"LocationsHeader-item--bo2rb","icon":"LocationsHeader-icon--uPcOp","hint":"LocationsHeader-hint--1oWuk","noLocation":"LocationsHeader-noLocation--11mRu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapPanel/CreateSegment/LocationsHeader/LocationsHeader.scss
// module id = Zkig
// module chunks = 4